import React, {useEffect, useState} from "react";
import "./style.css";
import {formatCheeseName} from "../../../../../utils/common";

import { Image } from "../../../../../components/Image";
export const MobileProfileSummary = ({ bmi, left, data }) => {



  return (
    <div className="profile-summary-mobile" data-model-id="16759:1528">

      <div className="div">
        <h1 className="text-center text-[24px] leading-[28px] font-[600] tracking-[0px] text-[#151E13] mb-[24px]">
          Summary of Your Personal Profile
        </h1>

        <div className="container">
          <div className="frame-2">
            <div className="BMI-label-wrapper">
              <p className="BMI-label">Your Body Mass Index (BMI)</p>
            </div>

            <div className="frame-3">
              <div className="frame-4">
                <div className="frame-5" />

                <div className="frame-6">
                  <div className="text-wrapper">Normal</div>

                  <div className="text-wrapper-2">Overweight</div>

                  <div className="text-wrapper-2">Obese</div>
                </div>
              </div>

              <div className="frame-7" style={{left}}>
                <div className="BMI-value-wrapper">
                  <div className="BMI-value">You - {bmi}</div>
                </div>

                <div className="BMI-indicator">
                  <Image src="/static/image/questionnaire/weight-loss/profileSummary/vector-2936.svg" alt="Vector" className="vector" />

                  <div className="ellipse" />
                </div>
              </div>
            </div>
            {bmi > 24 && <div className="risk-container">
              <div className="risk-info">
                <Image src="/static/image/questionnaire/weight-loss/profileSummary/icon-alert.png" alt="Icon alert" className="icon-alert" />

                <div className="risk-title">Risk of unhealthy BMI</div>
              </div>

              <p className="risk-description">
                Higher risk of heart disease, stroke, diabetes, and chronic
                pain.
              </p>
            </div>}
          </div>

          <div className="frame-8">
            <div className="area">
              <div className="list">
                <Image src="/static/image/questionnaire/weight-loss/profileSummary/icon-age.png" alt="Icon age" className="img" />

                <div className="goal">
                  <div className="text-wrapper-3">Age</div>

                  <div className="fitness-level">{data.age}</div>
                </div>
              </div>

              <div className="list">
                <Image src="/static/image/questionnaire/weight-loss/profileSummary/icon-target.png" alt="Icon target" className="img" />

                <div className="goal">
                  <div className="text-wrapper-3">Target Weight</div>

                  <div className="fitness-level">{data.targetWeight.weight} {data.targetWeight.unit}</div>
                </div>
              </div>

              <div className="list">
                <Image src="/static/image/questionnaire/weight-loss/profileSummary/icon-active.png" alt="Icon active" className="img" />

                <div className="goal">
                  <div className="text-wrapper-3">Activity Level</div>

                  <div className="fitness-level">{data.activityLevel}</div>
                </div>
              </div>
            </div>

            <div className="f">
              <div className="overlap-group">
                <Image src={`/static/image/questionnaire/weight-loss/profileSummary/ProfileSummary${formatCheeseName(data.gender)}${formatCheeseName(data.targetBodyType, "")}.png`} alt="Beautiful shadows" className="beautiful-shadows" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
